"use client"
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import dynamic from 'next/dynamic'
import { LoggedInUser } from "@/hooks/use-auth-user";
import type { ProjectsSessionUser } from "@/lib/projects-session";

const ProjectsHome = dynamic(() => import('@external/projects/home'), { ssr: false })

export default function Projects({
  loggedInUser,
  projectsUser,
}: {
  loggedInUser?: LoggedInUser | null;
  projectsUser?: ProjectsSessionUser | null;
}) {
    return (
      <>
        <Navbar loggedInUser={loggedInUser} activePage="projects" />
        <ProjectsHome projectsUser={projectsUser} />
        <Footer />
      </>
    );
  }
  